/**
 * DevExtreme (ui/html_editor/matchers/newLine.js)
 * Version: 19.2.13
 * Build date: Fri Dec 03 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

function isLine(node) {
    if (0 === node.childNodes.length) {
        return false
    }
    return ["address", "article", "blockquote", "canvas", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "iframe", "li", "main", "nav", "ol", "output", "p", "pre", "section", "table", "td", "tr", "ul", "video"].indexOf(node.tagName.toLowerCase()) !== -1
}

function deltaEndsWithNewLine(delta) {
    var _ref = delta.ops[delta.ops.length - 1] || {},
        text = _ref.insert;
    if ("string" !== typeof text) {
        return false
    }
    return "\n" === text.slice(-1)
}
var getMatcher = function() {
    return function(node, delta) {
        if (!deltaEndsWithNewLine(delta)) {
            if (isLine(node)) {
                return delta.insert("\n")
            }
        }
        return delta
    }
};
exports.default = getMatcher;
